import React from 'react';
import PropTypes from 'prop-types';
import './SelectedTeamChessRunning.css';

// Placeholder component for displaying the selected Chess team in Running state
const SelectedTeamChessRunning = ({ team, contest }) => {
  // TODO: Implement logic to display details of the selected Chess team
  // console.log("SelectedTeamChessRunning loaded for team:", team, "contest:", contest);

  // Placeholder rendering
  return (
    <div className="selected-team-container">
      <h4>Selected Chess Team: {team.entryName}</h4>
      <p>Display selected Chess team details (players, ratings, etc.) here.</p>
      {/* Example:
      <ul>
        {team.players?.map(player => (
          <li key={player.playerId}>{player.name} - Rating: {player.sportSpecificData?.currentRating || 'N/A'}</li>
        ))}
      </ul>
      */}
    </div>
  );
};

SelectedTeamChessRunning.propTypes = {
  team: PropTypes.object.isRequired,
  contest: PropTypes.object.isRequired,
};

export default SelectedTeamChessRunning; 